import React, { Component } from 'react';
import classnames from 'classnames';
import _ from 'underscore';

class GroupFilterItemView extends Component {

    handleChange = (keyName) => {
        this.props.handleChange(keyName);
    }

    displayData(key, count = 0) {
        switch (this.props.group) {
        case 'title':
            return key + '  (' + count + ')';
        case 'company':
            return key + '  (' + count + ')';
        case 'country':
            return key + '  (' + count + ')';
        }
    }

    render() {
        let cx = classnames;
        let filteredFacet = this.props.facets[this.props.group] || {};
        let isSelected = _.findWhere(this.props.attributeSelected, {keyName: this.props.keyName});
        let selected = cx('group-cell-item no-style-link-button', {
            'color-1 color-1-border group-selected': isSelected,
            'group-cell-item-ellipsis': this.props.ellipsis
        });

        return (
            <button className={selected} key={this.props.keyName}
                onClick={this.handleChange.bind(this, this.props.keyName)}>{this.displayData(this.props.keyName, filteredFacet[this.props.keyName])}</button>
        );
    }
}

export default GroupFilterItemView;


